import { capitalCase, dotCase } from 'change-case'
export default {
    data: () => ({
        permissionTypes: ['Create', 'View', 'Update', 'Delete'],
        permissionSection: null,
    }),
    computed: {
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        permissionSections() {
            const routes = this.$router.options.routes || []
            const dashboardLayout = routes.find(
                x => x.name === 'dashboardLayout'
            )
            const _sections = (dashboardLayout.children || [])
                .filter(x => x.meta && x.meta.group)
                .map(x => capitalCase(x.name))
            ///for mobile permissions
            _sections.push('Assigned Exception')
            console.log('valid permission sections', _sections)
            return _sections
        },

        hasPermissionCreate() {
            return this.checkPermissionAction('create')
        },

        hasPermissionView() {
            return this.checkPermissionAction('view')
        },

        hasPermissionUpdate() {
            return this.checkPermissionAction('update')
        },

        hasPermissionDelete() {
            return this.checkPermissionAction('delete')
        },
    },

    watch: {
        hasPermissionCreate: function(val) {
            this.$set(this.$userPermissions, 'hasPermissionCreate', val)
        },
        hasPermissionDelete: function(val) {
            this.$set(this.$userPermissions, 'hasPermissionDelete', val)
        },
        hasPermissionUpdate: function(val) {
            this.$set(this.$userPermissions, 'hasPermissionUpdate', val)
        },
        hasPermissionView: function(val) {
            this.$set(this.$userPermissions, 'hasPermissionView', val)
        },
    },

    created() {
        //set permission section to controller name
        const section = this.$options.name.split('-')[0]
        let permissionSection = capitalCase(section)
        this.permissionSection = permissionSection
        console.log('permissionSection', permissionSection)
        this.$userPermissions = {}
    },
    mounted() {
        this.$set(
            this.$userPermissions,
            'hasPermissionCreate',
            this.hasPermissionCreate
        )
        this.$set(
            this.$userPermissions,
            'hasPermissionDelete',
            this.hasPermissionDelete
        )
        this.$set(
            this.$userPermissions,
            'hasPermissionUpdate',
            this.hasPermissionUpdate
        )
        this.$set(
            this.$userPermissions,
            'hasPermissionView',
            this.hasPermissionView
        )
    },

    methods: {
        getComponentPermissions() {
            const {
                hasPermissionCreate,
                hasPermissionDelete,
                hasPermissionUpdate,
                hasPermissionView,
            } = this
            return {
                hasPermissionCreate,
                hasPermissionDelete,
                hasPermissionUpdate,
                hasPermissionView,
            }
        },
        setPermissionSection(section) {
            section = capitalCase(section)
            if (!this.permissionSections.includes(section))
                throw new Error('Illegal Permission Section')
            this.permissionSection = section
        },

        checkPermissionAction(action) {
            if (!this.permissionSection) return false
            if (!this.permissionSections.includes(this.permissionSection)) {
                console.log(
                    'permission section not found:',
                    this.permissionSection
                )
                return false
            }
            const section = dotCase(this.permissionSection)
            return this.user_permissions.includes(`${action}.${section}`)
        },
    },
}
